export default __webpack_public_path__ + "static/media/links-jnodepf.8d8b0c16.png";